import WebServiceRequest from "../../../Api/WebServiceRequest";

class updateAPhysicalCategory extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PhysicalCategory/Update");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}
export default updateAPhysicalCategory;
